import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_ONE_ARTICLE_TOTAL = 'API_GET_ONE_ARTICLE_TOTAL';
/**
 * 各記事の総件数を取得する
 * @param params
 * @param meta
 * @returns {*}
 */
export const apiGetOneArticleTotal = (params, meta) => apiGetList(API_GET_ONE_ARTICLE_TOTAL, '/article/total', {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
